import authCheckApp from './authCheckApp'

/**
 * 换起更新弹窗（webview）
 * @since 1.0.0
 * @example
 * 
 * apiCheckAppUpdate()
 */
function apiCheckAppUpdate() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('apiCheckAppUpdate', {}, (response) => {
                return response
            })
        }).catch(err => {
            Promise.reject(err)
        })
}

export default apiCheckAppUpdate